
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { Cropper } from 'vue-advanced-cropper'

export default {
  props: {
    image: {
      type: String,
      default: '/images/defaultLogoCampaign.png',
    },
    showCrop: {
      type: Boolean,
      default: false,
    },
    userView: {
      type: Boolean,
      default: false,
    },
  },
  components: { Dialog, Button, Cropper },
  setup(props: any, ctx: any) {
    const show = ref(false);
    const dataURL = ref();
    const color = ref('black');

    watch(() => props.showCrop, () => {
      show.value = props.showCrop;
    })

    const cropMainImage = (e: { canvas: any }) => {
      dataURL.value = e.canvas.toDataURL('image/png');
    };

    const saveChanges = () => {
      ctx.emit('change', dataURL.value);
    }

    return {
      show,
      dataURL,
      color,
      saveChanges,
      cropMainImage,
    };
  },
};
